import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-715fa14d")

_pushScopeId("data-v-715fa14d")
const _hoisted_1 = { class: "container all-documents" }
const _hoisted_2 = { class: "documents-page-title" }
const _hoisted_3 = { class: "documents-search" }
const _hoisted_4 = { class: "documents-search-filter" }
const _hoisted_5 = { style: {"display":"flex"} }
const _hoisted_6 = { class: "search-button-wrapper pl-15" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_8 = { class: "documents-search-total" }
const _hoisted_9 = { class: "show-all-clear-filter" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "documents-filter-circle"
}
const _hoisted_12 = { class: "documents-total" }
const _hoisted_13 = {
  key: 0,
  class: "mobile-grid"
}
const _hoisted_14 = { class: "w100" }
const _hoisted_15 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_16 = { class: "documentNumber" }
const _hoisted_17 = { class: "table-text-setting" }
const _hoisted_18 = { class: "table-text-setting" }
const _hoisted_19 = { class: "customer-padding" }
const _hoisted_20 = { class: "table-text-setting" }
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-ellipsis fs-16 ellipsis-icon" }, null, -1)
const _hoisted_22 = {
  key: 1,
  class: "desktop-grid"
}
const _hoisted_23 = { class: "w100" }
const _hoisted_24 = { class: "desktop-table-actions" }
const _hoisted_25 = { class: "thead-cell-center" }
const _hoisted_26 = { class: "documentNumber" }
const _hoisted_27 = { class: "desktop-table-text-setting doc-type" }
const _hoisted_28 = { class: "desktop-table-text-setting provider-name" }
const _hoisted_29 = { class: "cuted-cell" }
const _hoisted_30 = { class: "desktop-table-text-setting pl-20" }
const _hoisted_31 = { class: "desktop-table-text-setting customer" }
const _hoisted_32 = { class: "cuted-cell" }
const _hoisted_33 = { class: "desktop-table-text-setting" }
const _hoisted_34 = { class: "desktop-table-text-setting user" }
const _hoisted_35 = { class: "cuted-cell" }
const _hoisted_36 = { class: "desktop-table-actions" }
const _hoisted_37 = {
  class: "mobile-documents-actions",
  id: "mobile-documents-actions"
}
const _hoisted_38 = { class: "action-item" }
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-share fs-26 ellipsis-icon" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-eye fs-26 ellipsis-icon he-ellipsis-icon" }, null, -1)
const _hoisted_41 = { class: "actions-documents-back-block" }
const _hoisted_42 = { class: "footer-documents" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('product.documents')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _withDirectives(_createVNode("input", {
            class: "bookit-input order-input",
            id: "datetime",
            type: "text",
            placeholder: _ctx.$t('placeholder.searchByNumberTypeOrCustomerName'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchInput = $event))
          }, null, 8, ["placeholder"]), [
            [_vModelText, _ctx.searchInput]
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getDocumentsOnClick()))
            }, [
              _hoisted_7
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("span", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
          }, _toDisplayString(_ctx.$t('button.showAll')), 1)
        ]),
        _createVNode("div", {
          class: ["documents-filter", { hasFilter: _ctx.hasFilter }]
        }, [
          _createVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goFilter())),
            type: "button"
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
            _hoisted_10
          ]),
          (_ctx.hasFilter)
            ? (_openBlock(), _createBlock("div", _hoisted_11, "!"))
            : _createCommentVNode("", true)
        ], 2),
        _createVNode("div", _hoisted_12, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('documents.totalDocuments')) + ":", 1),
          _createVNode("div", null, _toDisplayString(_ctx.rowsCount) + " " + _toDisplayString(_ctx.$t('documents.ofDoc', { quantityOfDocuments: _ctx.total })), 1)
        ])
      ])
    ]),
    (_ctx.documents && _ctx.documents.length)
      ? (_openBlock(), _createBlock("div", _hoisted_13, [
          _createVNode("table", _hoisted_14, [
            _createVNode("thead", null, [
              _createVNode("tr", null, [
                _createVNode("td", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sotrBy('Number'))),
                  class: ""
                }, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('documents.number')), 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Number')]
                  }, null, 2)
                ]),
                _createVNode("td", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sotrBy('Type')))
                }, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('documents.type')), 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Type')]
                  }, null, 2)
                ]),
                _createVNode("td", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sotrBy('Customer')))
                }, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('documents.customer')), 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Customer')]
                  }, null, 2)
                ]),
                _createVNode("td", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sotrBy('Date')))
                }, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('priceList.date')), 1),
                  _createVNode("i", {
                    class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Date')]
                  }, null, 2)
                ]),
                _hoisted_15
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.documents, (doc) => {
                return (_openBlock(), _createBlock("tr", {
                  key: doc.documentNumber
                }, [
                  _createVNode("td", _hoisted_16, [
                    (doc.documentType == _ctx.DocumentType.Invoice)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: { name: 'invoice', params: { invoiceId: doc.id } },
                          class: "text-link"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(doc.documentNumber), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true),
                    (doc.documentType == _ctx.DocumentType.Receipt)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: { name: 'receipt', params: { receiptId: doc.id } },
                          class: "text-link"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(doc.documentNumber), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true),
                    (doc.documentType == _ctx.DocumentType.Voucher)
                      ? (_openBlock(), _createBlock("a", {
                          key: 2,
                          href: doc.pdfUrl,
                          target: "_blank",
                          class: "text-link"
                        }, _toDisplayString(doc.documentNumber), 9, ["href"]))
                      : _createCommentVNode("", true),
                    (doc.documentType == _ctx.DocumentType.InvoiceReceipt)
                      ? (_openBlock(), _createBlock("a", {
                          key: 3,
                          href: doc.pdfUrl,
                          target: "_blank",
                          class: "text-link"
                        }, _toDisplayString(doc.documentNumber), 9, ["href"]))
                      : _createCommentVNode("", true),
                    (doc.documentType == _ctx.DocumentType.OrderSummary)
                      ? (_openBlock(), _createBlock("a", {
                          key: 4,
                          href: doc.pdfUrl,
                          target: "_blank",
                          class: "text-link"
                        }, _toDisplayString(doc.documentNumber), 9, ["href"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_17, _toDisplayString(_ctx.getDocumentType(doc)), 1),
                  _createVNode("td", _hoisted_18, [
                    _createVNode("div", _hoisted_19, _toDisplayString(doc.customer), 1)
                  ]),
                  _createVNode("td", _hoisted_20, _toDisplayString(_ctx.moment(doc.createDate).format('DD/MM/YYYY')), 1),
                  _createVNode("td", {
                    onClick: ($event: any) => (_ctx.showMobileActions(doc)),
                    class: "ellipsis-td"
                  }, [
                    _hoisted_21
                  ], 8, ["onClick"])
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.documents && _ctx.documents.length)
      ? (_openBlock(), _createBlock("div", _hoisted_22, [
          _createVNode("table", _hoisted_23, [
            _createVNode("thead", null, [
              _createVNode("tr", null, [
                _createVNode("td", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sotrBy('Number')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.number')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Number')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sotrBy('Type')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.type')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Type')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sotrBy('ProviderName')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.providerName')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ProviderName')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sotrBy('ProviderId'))),
                  class: "pl-20"
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.providerId')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ProviderId')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sotrBy('Customer')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.customer')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Customer')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sotrBy('Date')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('priceList.date')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Date')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sotrBy('User')))
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('documents.user')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('User')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", _hoisted_24, [
                  _createVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('customerType.actions')), 1)
                ])
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.documents, (doc, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", _hoisted_26, [
                    (doc.documentType == _ctx.DocumentType.Invoice)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: { name: 'invoice', params: { invoiceId: doc.id } },
                          class: "text-link"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(doc.documentNumber), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true),
                    (doc.documentType == _ctx.DocumentType.Receipt)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: { name: 'receipt', params: { receiptId: doc.id } },
                          class: "text-link"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(doc.documentNumber), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true),
                    (doc.documentType == _ctx.DocumentType.Voucher)
                      ? (_openBlock(), _createBlock("a", {
                          key: 2,
                          href: doc.pdfUrl,
                          target: "_blank",
                          class: "text-link"
                        }, _toDisplayString(doc.documentNumber), 9, ["href"]))
                      : _createCommentVNode("", true),
                    (doc.documentType == _ctx.DocumentType.InvoiceReceipt)
                      ? (_openBlock(), _createBlock("a", {
                          key: 3,
                          href: doc.pdfUrl,
                          target: "_blank",
                          class: "text-link"
                        }, _toDisplayString(doc.documentNumber), 9, ["href"]))
                      : _createCommentVNode("", true),
                    (doc.documentType == _ctx.DocumentType.OrderSummary)
                      ? (_openBlock(), _createBlock("a", {
                          key: 4,
                          href: doc.pdfUrl,
                          target: "_blank",
                          class: "text-link"
                        }, _toDisplayString(doc.documentNumber), 9, ["href"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_27, _toDisplayString(_ctx.getDocumentType(doc)), 1),
                  _createVNode("td", _hoisted_28, [
                    _createVNode("span", _hoisted_29, _toDisplayString(doc.providerName), 1)
                  ]),
                  _createVNode("td", _hoisted_30, _toDisplayString(doc.providerId), 1),
                  _createVNode("td", _hoisted_31, [
                    _createVNode("span", _hoisted_32, _toDisplayString(doc.customer), 1)
                  ]),
                  _createVNode("td", _hoisted_33, [
                    _createVNode("div", null, _toDisplayString(_ctx.moment(doc.createDate).format("DD/MM/YYYY")), 1),
                    _createVNode("div", null, _toDisplayString(_ctx.moment(doc.createDate).format("HH:mm")), 1)
                  ]),
                  _createVNode("td", _hoisted_34, [
                    _createVNode("span", _hoisted_35, _toDisplayString(doc.creator), 1)
                  ]),
                  _createVNode("td", _hoisted_36, [
                    _createVNode("i", {
                      class: "icon-f icon-share fs-26 ellipsis-icon",
                      onClick: ($event: any) => (_ctx.shareDocument(doc))
                    }, null, 8, ["onClick"]),
                    _createVNode("i", {
                      class: ["icon-f icon-eye fs-26 ellipsis-icon", { 'blue-color': doc.pdfUrl }],
                      onClick: ($event: any) => (_ctx.showPdf(doc))
                    }, null, 10, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_37, [
      _createVNode("div", {
        class: "mobile-documents-actions-buttons",
        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.shareDocument(_ctx.selectedDocument)))
      }, [
        _createVNode("div", _hoisted_38, [
          _hoisted_39,
          _createVNode("div", null, _toDisplayString(_ctx.$t('documents.share')), 1)
        ]),
        _createVNode("div", {
          class: "action-item",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showPdf(_ctx.selectedDocument)))
        }, [
          _hoisted_40,
          _createVNode("div", null, _toDisplayString(_ctx.$t('documents.preview')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_41, [
        _createVNode("button", {
          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.closeMobileActions())),
          class: "order-modify-button-wrapper back-myorders",
          style: {"position":"relative"},
          type: "button"
        }, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('button.back')), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_42, [
      _createVNode("button", {
        class: "order-modify-button-wrapper back-myorders",
        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.back())),
        style: {"position":"relative"},
        type: "button"
      }, _toDisplayString(_ctx.$t('button.back')), 1),
      _createVNode("button", {
        class: "order-modify-button-wrapper green-circle-button",
        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.goOrders())),
        style: {"position":"relative"},
        type: "button"
      }, _toDisplayString(_ctx.$t('orders.orders')), 1)
    ])
  ]))
})